import { render, staticRenderFns } from "./RGBSpinner.vue?vue&type=template&id=378811c6"
import script from "./RGBSpinner.vue?vue&type=script&lang=js"
export * from "./RGBSpinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports